module.exports = __webpack_public_path__ + "img/1.afea9f0f.png";